import { render } from "./LocationClicks.vue?vue&type=template&id=191332a0"
import script from "./LocationClicks.vue?vue&type=script&lang=js"
export * from "./LocationClicks.vue?vue&type=script&lang=js"

import "./LocationClicks.vue?vue&type=style&index=0&id=191332a0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__